window.$s = window.$s || {};
(function(helper) {

/* bundles management*/
  helper.getItemsToUpdate = function(sourceItem, newQuantity) {
    var items = [sourceItem];
    if (sourceItem.dataset.bundleId && sourceItem.dataset.bundleItem != 'individual') {
      if (newQuantity == 0) {
        items = sourceItem.parentNode.querySelectorAll('[data-bundle-id="' + sourceItem.dataset.bundleId + '"]');
      } else {
        items = sourceItem.parentNode.querySelectorAll('[data-bundle-id="' + sourceItem.dataset.bundleId + '"][data-bundle-item="main"], [data-bundle-id="' + sourceItem.dataset.bundleId + '"][data-bundle-item="related_multiple"]');
      } 
      items = Array.from(items);
    }
    var sourceItemKey = sourceItem.dataset.key;
    var hasProtectionItems = sourceItem.parentNode.querySelectorAll(`[data-key="${sourceItemKey}"],[data-protection-key="${sourceItemKey}"]`);
    if(hasProtectionItems.length){
      items = Array.from(hasProtectionItems);
    }
    console.log(hasProtectionItems,hasProtectionItems.length, sourceItemKey);
    return items;
  }

/*
  items: is a list of div.item nodes that are cart items from the cart page or side cart
  mustFixItems: is a boolean, default is true
  callback: function to be called after validation and fixing items if required. The callback first argument receives the result of the validation (true, or false if there was a problem), default callback triggers a location.reload() when the cart had to be fixed;
  */
  helper.validateBundlesInHTML = function(items, mustFixItems, callback) {
    var data = {
      items: []
    };
    items.forEach(function(item) {
      var obj = {
        key: item.dataset.key,
        properties: {},
        quantity: 1 // item.querySelector('[name="updates[]"]').value / 1
      }
      if (item.dataset.bundleId) {
        obj.properties['_bundle_id'] = item.dataset.bundleId;
        obj.properties['_bundle_item'] = item.dataset.bundleItem;
        data.items.push(obj);
      }
    });
    validateBundles(data, mustFixItems, callback);
  }

/*
  items: is a list of div.item nodes that are cart items from the cart page or side cart
  mustFixItems: is a boolean, default is true
  callback: function to be called after validation and fixing items if required. The callback first argument receives the result of the validation (true, or false if there was a problem), default callback triggers a location.reload() when the cart had to be fixed;
  */
  helper.validateBundlesInJson = function(items, mustFixItems, callback) {
    var data = {
      items: items
    };
    validateBundles(data, mustFixItems, callback);
  }

  function validateBundles(data, mustFixItems, callback) {
    var bundles = {};
    if (typeof(mustFixItems) == 'undefined') {
      mustFixItems = true;
    }
    var dataUpdate = {
      updates: {}
    };
    data.items.forEach(function(item) {
      var id = item.properties._bundle_id;
      if (id && item.properties._bundle_item != 'individual') {
        if (! bundles[id]) {
          bundles[id] = []
        }
        bundles[id].push(item);
      }
    });
    for (var id in bundles) {
      var items = bundles[id];

// reduce quantity of items limited to 1
      items.forEach(function(item) {
        if (item.properties._bundle_item == 'related_single' && item.quantity > 1) {
          dataUpdate.updates[item.key] = 1
        }
      })

// delete the items without main
      if (! items.find((x) => x.properties._bundle_item == 'main')) {
        items.forEach((item) => dataUpdate.updates[item.key] = 0);
      }

    }

    if (Object.keys(dataUpdate.updates).length) {
      if (mustFixItems) {
        $s.showLoadingOverlay();
        $s.post({
          type: 'POST',
          url: '/cart/update.js',
          data: dataUpdate,
          dataType: 'json',
          success: function() {
            if (callback) {
              $s.hideLoadingOverlay();
              callback(false);
            } else {
              location.reload();
            }
          },
          error: $s.addToCartFail
        });
      } else {
        if (callback) {
          callback(false);
        }
      }

    } else {
      if (callback) {
        callback(true);
      }
    }

  }

})($s);